import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AnalyticsDirectivesModule } from '@analytics/events';
import { CoreJssProxyModule } from '@core/jss-proxy';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import {
  CSCaptureDirective,
  CSMaskDirective,
} from '@legacy/utils-contentsquare';

import { BackButtonMobileComponent } from './back-button-mobile/back-button-mobile.component';
import { BackButtonSidebarComponent } from './back-button-sidebar/back-button-sidebar.component';
import { BackButtonComponent } from './back-button-sidebar/back-button.component';
import { MijnInformationBlockContainerComponent } from './mijn-information-block/mijn-information-block-container/mijn-information-block-container.component';
import { MijnInformationBlockComponent } from './mijn-information-block/mijn-information-block.component';

@NgModule({
  imports: [
    CommonModule,
    CommonUiUtilityComponentsModule,
    CoreJssProxyModule,
    AnalyticsDirectivesModule,
    FontAwesomeModule,
    CSCaptureDirective,
    CSMaskDirective,
    MijnInformationBlockComponent,
    MijnInformationBlockContainerComponent,
    BackButtonSidebarComponent,
    BackButtonMobileComponent,
    BackButtonComponent,
  ],
  exports: [
    MijnInformationBlockContainerComponent,
    BackButtonSidebarComponent,
    BackButtonMobileComponent,
    BackButtonComponent,
  ],
})
export class CommonUiMijnRenderingsModule {}
